export default __webpack_public_path__ + "static/media/Comp 2_00000.9e4fe404.png";